import { render, staticRenderFns } from "./TaxInput.vue?vue&type=template&id=b11e2d66&scoped=true&lang=pug&"
import script from "./TaxInput.vue?vue&type=script&lang=ts&"
export * from "./TaxInput.vue?vue&type=script&lang=ts&"
import style0 from "./TaxInput.vue?vue&type=style&index=0&id=b11e2d66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11e2d66",
  null
  
)

export default component.exports